"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/b9-web-exchange/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime.js");

var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/b9-web-exchange/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));

var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/b9-web-exchange/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js"));

var _index = require("@/model/exchange/index");

var _record = _interopRequireDefault(require("./components/transaction/record.vue"));

var _recordExchange = _interopRequireDefault(require("./components/transaction/recordExchange.vue"));

var _recordDelivery = _interopRequireDefault(require("./components/transaction/recordDelivery.vue"));

var _digital = require("@/assets/js/digital");

var _commonMixin = _interopRequireDefault(require("@/components/common/commonMixin.vue"));

var _stationSetting = require("@/assets/js/stationSetting");

var _menuControlMixin = _interopRequireDefault(require("@/components/common/menuControlMixin.vue"));

var _vuex = require("vuex");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  mixins: [_commonMixin.default, _menuControlMixin.default],
  components: {
    Record: _record.default,
    RecordExchange: _recordExchange.default,
    RecordDelivery: _recordDelivery.default
  },
  data: function data() {
    return {
      current_profit: "",
      profit_rate: "",
      WEB_OPEN_COINM: _stationSetting.WEB_OPEN_COINM,
      assetsShowCurrency: {
        aed: "--",
        cny: "--",
        cnye: "--",
        hkd: "--",
        jpy: "--",
        krw: "--",
        usd: "--",
        usdt: "--"
      },
      active: 1,
      currIndex: 3,
      tabList: [// {
        //   value: "3",
        //   label: "币币交易"
        // },
        // {
        //   value: "1",
        //   label: "U本位合约"
        // },
        // {
        //   value: "2",
        //   label: "币本位合约"
        // }
        // {
        //   value: "4",
        //   label: "股票交易",
        // },
        // {
        //   value: "5",
        //   label: "超级杠杆",
        // },
      ]
    };
  },
  created: function created() {
    var _this = this;

    return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (_this.isHideLever) {
                _this.tabList = [{
                  value: "3",
                  label: "币币交易"
                } // {
                //   value: "1",
                //   label: "U本位合约"
                // },
                // {
                //   value: "2",
                //   label: "币本位合约"
                // }
                ];
              } else if (_stationSetting.WEB_OPEN_COINM != 1) {
                _this.tabList = [{
                  value: "3",
                  label: "币币交易"
                }, {
                  value: "1",
                  label: "U本位合约"
                }];
              } else {
                _this.tabList = [{
                  value: "3",
                  label: "币币交易"
                }, {
                  value: "1",
                  label: "U本位合约"
                }, {
                  value: "2",
                  label: "币本位合约"
                }];
              } // 交易管理开始


              _this.getWebAssets();

              _this.startAssetsTimer(); // 交易管理结束


            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  destroyed: function destroyed() {},
  beforeDestroy: function beforeDestroy() {},
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)({
    language: "user/language",
    systemCurrency: "user/currency"
  })),
  methods: {
    // 交易管理开始
    startAssetsTimer: function startAssetsTimer() {
      var _this2 = this;

      this.getWebAssets().then(function () {
        var timer = setTimeout(function () {
          _this2.startAssetsTimer();
        }, 6000);

        _this2.$once("hook:beforeDestroy", function () {
          clearTimeout(timer);
        });
      });
    },
    getWebAssets: function getWebAssets() {
      var _this3 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var params, _yield$apiGetWebAsset, status, data;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                params = {
                  type: "all"
                };
                _context2.next = 3;
                return (0, _index.apiGetWebAssets)(params);

              case 3:
                _yield$apiGetWebAsset = _context2.sent;
                status = _yield$apiGetWebAsset.status;
                data = _yield$apiGetWebAsset.data;

                if (status == 200) {
                  // this.contractMap = data.contract;
                  if (_this3.currIndex == 1) {
                    _this3.assetsShowCurrency = data.contract.all_u_valuation;
                    _this3.current_profit = data.contract.all_current_profit;
                    _this3.profit_rate = (0, _digital.paddingNumberRight)(data.contract.profit_rate, 2);
                  } else if (_this3.currIndex == 2) {
                    _this3.assetsShowCurrency = data.future.all_u_valuation;
                    _this3.current_profit = data.future.all_current_profit;
                    _this3.profit_rate = (0, _digital.paddingNumberRight)(data.future.profit_rate, 2);
                  } else if (_this3.currIndex == 3) {
                    _this3.assetsShowCurrency = data.remain.all_u_valuation;
                  }
                }

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    onAreaChange: function onAreaChange(item) {
      this.currIndex = item.value;
      this.getWebAssets();
    } // 交易管理结束

  }
};
exports.default = _default;